<template>
  <div class="mainContent startInstructionsDiv">
    <div class="mainContent__paragraphs">
      <p>
        O envio de pedido foi configurado com sucesso.
        Agora, para receber atualizações de ocorrências dos pedidos,
        é necessária uma configuração adicional.
      </p>
      <p>
        Entre em <a href="https://direct.uber.com/developer">direct.uber.com</a> e acesse sua conta da Uber.
        Em seguida, siga os passos abaixo:
      </p>
      <p><ol>
        <li>
          Clique na aba <b>Desenvolvedor (Developer)</b> à esquerda e em seguida na aba <b>Webhooks</b>.
          <br />
          <img src="https://d1a3f4spazzrp4.cloudfront.net/uberex/duc/webhooks-screen.png" alt="webhook">
        </li>
        <li>
          Clique em <b>Criar rota (Create endpoint)</b>.
          <br />
          <img src="https://d1a3f4spazzrp4.cloudfront.net/uberex/duc/createEndpoint-screen.png" alt="create endpoint">
        </li>
        <li>
          Copie a URL abaixo e cole no campo <b>URL de Webhook (Webhook URL)</b>:
          <sc-field>
          <sc-input class="mainContent__input" id="webhook_url"
            :value="`https://0v8nee4iig.execute-api.sa-east-1.amazonaws.com/prd/app/otu56i2/tracking?installation-id=${installationId}`"
            readonly expanded/>

          <p class="control">
            <sc-tooltip label="Copiar" position="is-bottom">
              <sc-button
                id="copy-target-content"
                theme="primary"
                icon="copy"
                :text="copyText"
                data-clipboard-target="#webhook_url"/>
              </sc-tooltip>
            </p>
        </sc-field>
        </li>
        <li>
          Logo abaixo, na seção de eventos, habilite apenas a opção <b>event.delivery_status</b>.
        </li>
        <li>
          Para finalizar, clique em <b>Criar (Create)</b>.
        </li>
      </ol></p>
      <p>
        Após realizada essa configuração,
        a integração já estará pronta para receber atualizações dos pedidos.
      </p>
    </div>

    <help-button/>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScField,
    ScIcon,
    ScInput,
    ScTooltip,
  } from '@intelipost-js/secure-components';
  import { Clipboard } from '@intelipost-js/secure-providers';

  import HelpButton from './base/HelpButton.vue';

  const { mapState } = createNamespacedHelpers('integrations/integrationsAppSelfService');

  export default {
    name: 'sc-instructions',
    components: {
      ScButton,
      ScField,
      ScIcon,
      ScInput,
      ScTooltip,
      HelpButton,
    },
    data() {
      return {
        copyText: '',
        clipboard: null,
      };
    },
    mounted() {
      this.clipboard = new Clipboard('#copy-target-content');
      this.clipboard.on('success', () => {
        this.copyText = 'Copiado para sua área de transferência!';
        setTimeout(() => {
          this.copyText = null;
        }, 1000);
      });
    },
    destroyed() {
      if (this.clipboard) {
        this.clipboard.listener.destroy();
      }
    },
    computed: {
      ...mapState([
        'installationId',
      ]),
    },
  };
</script>

<style lang='scss' scoped>
  .mainContent {
    display: flex;
    gap: 50px;
    flex-direction: column;

    &__paragraphs p {
      margin-bottom: 1em;
    }

    &__input {
      display: inline-flex;
      width: 20rem;
    }

    ol {
      margin-left: 2em;
    }

    img {
      max-width: 80%;
    }

  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/ScInstructions.vue